import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const steps = ['Entra al link', 'Selecciona el ritual que quieres', 'Crea tu cuenta como "CLIENTE"', 'Rellena los datos de usuario', 'Rellena dirección de entrega y método de pago'];
export function HowToBuyAccordion() {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="w-full max-w-xl mx-auto mt-8 text-left" data-id="element-107" data-mp="2kcqmw0ppzf2w">
      <button type="button" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} aria-controls="como-comprar-panel" className="w-full flex items-center justify-between gap-4 px-6 py-4 bg-white/80 backdrop-blur-sm border border-brand-beige rounded-2xl hover:bg-white transition-colors" data-id="element-108" data-mp="2ka4exzyx2xk5">
        <span className="font-serif text-lg font-medium text-brand-charcoal" data-id="element-109" data-mp="340r5arqfsvvf">
          ¿Cómo comprar?
        </span>
        <ChevronDown className={`w-5 h-5 text-brand-sage flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} style={{
        transitionTimingFunction: 'cubic-bezier(0.23, 1, 0.32, 1)'
      }} data-id="element-110" data-mp="382co0tpnk4dj" />
      </button>

      <AnimatePresence initial={false} data-id="element-111" data-mp="nf9pxums4vd8">
        {isOpen && <motion.div id="como-comprar-panel" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-112" data-mp="nhw4wfc02d5h">
            <div className="mt-3 px-6 py-6 bg-white/80 backdrop-blur-sm border border-brand-beige rounded-2xl" data-id="element-113" data-mp="11dzxk4786dfu">
              <p className="text-sm text-brand-charcoal/70 font-light leading-relaxed mb-6" data-id="element-114" data-mp="1u4i0n57y8et9">
                Bienvenida 🤍 Para comprar tu rutina o cualquier producto del
                catálogo tienes que crear tu cuenta como{' '}
                <span className="font-medium text-brand-charcoal" data-id="element-115" data-mp="3taewwejy2pt5">
                  “Cliente”
                </span>
                , así puedes recibir beneficios, información y más.
              </p>

              <ol className="space-y-4" data-id="element-116" data-mp="3jklmvhzgair0">
                {steps.map((step, index) => <li key={step} className="flex items-start gap-4" data-id="element-117" data-mp="35lm76ztx1e6z" data-mpi={index}>
                    <span className="flex-shrink-0 w-7 h-7 rounded-full bg-brand-cream text-brand-sage-dark font-serif text-sm flex items-center justify-center" data-id="element-118" data-mp="39nh9o7nl1xmc">
                      {index + 1}
                    </span>
                    <span className="text-brand-charcoal/80 font-light leading-relaxed pt-0.5" data-id="element-119" data-mp="30lzk7yoacjkz">
                      {step}
                    </span>
                  </li>)}
              </ol>

              <p className="mt-6 pt-6 border-t border-brand-beige text-sm text-brand-charcoal font-medium" data-id="element-120" data-mp="yud08h2t9oy0">
                ¡Y listooo! ✨🩷 Prepárate para recibir tu ritual de 2 a 5 días
                hábiles.
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}